import React from 'react'
// import "../assets/css/DataNotFound.css";

export default function DataNotFound() {

    return(
        <>
          <span className='data-not-found-text largerFont'>Data Not Found</span>
          <style jsx="true">
              {`
              .data-not-found-text {
                font-weight: 600;    
                height: 360px;            
                line-height: 22px;
                display: flex;
                color: #707070;
                justify-content: center;
                padding: 1rem 0;
            }
              `}
          </style>
        </>
    )
}